import React from 'react'
import HomeOverviewGrid from 'components/HomeOverviewGrid'
import { useLookupContext } from 'contexts/LookupContext'
import { useTextualContext } from 'contexts/TextualContext'
import PageContentWrapper from 'components/layout/Content/PageContentWrapper'
import NeedHelp from 'components/NeedHelp'
import PageHeading from 'components/PageHeading'

const HomePage = () => {
	const { t } = useTextualContext()
	const { selectedUser } = useLookupContext()
	const customerName = selectedUser?.customerName
	const [lastName, firstName] = customerName
		? customerName.split(',').map((name) => name.trim())
		: [null, null]

	const titleText = t('my-home.headline')
	const needHelpContent = t('my-home.need-help')
	return (
		<>
			<PageContentWrapper>
				<PageHeading
					titleText={`${titleText}${firstName ? firstName : ''} ${
						lastName ? lastName : ''
					}!`}
				/>
				<HomeOverviewGrid />
			</PageContentWrapper>
			<NeedHelp content={needHelpContent} />
		</>
	)
}

export default HomePage
